import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <section class="hero-redesign">
      <div class="hero-bg-shape"></div>
      <div class="container hero-flex">
        <div class="hero-content-redesign">
          <h1 class="hero-title">Donnez une seconde chance à vos invendus !</h1>
          <p class="hero-subtitle">
            Rejoignez Zero-Waste et transformez vos invendus en opportunités
            tout en luttant contre le gaspillage alimentaire.
          </p>
          <div class="hero-buttons-redesign">
            <a
              [routerLink]="['/create-account']"
              class="btn-hero btn-hero-primary"
            >
              <i class="fas fa-leaf"></i> Rejoindre Zero-Waste
            </a>
          </div>
        </div>
        <div class="hero-image-redesign">
          <img
            src="https://images.unsplash.com/photo-1542838132-92c53300491e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80"
            alt="Panier d'invendus alimentaires"
          />
        </div>
      </div>
    </section>
  `,
  styles: [
    `
      .hero-redesign {
        position: relative;
        padding: 120px 0 80px;
        background: linear-gradient(120deg, #f4f6f6 60%, #e0f7f7 100%);
        overflow: hidden;
      }
      .hero-bg-shape {
        position: absolute;
        top: -80px;
        right: -120px;
        width: 600px;
        height: 600px;
        background: radial-gradient(circle at 60% 40%, #c0e410 0%, #f4f6f6 80%);
        opacity: 0.15;
        z-index: 0;
        border-radius: 50%;
      }
      .hero-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 40px;
        position: relative;
        z-index: 1;
      }
      .hero-content-redesign {
        flex: 1;
        max-width: 540px;
      }
      .hero-title {
        font-size: 2rem;
        font-weight: 800;
        color: var(--text-color);
        margin-bottom: 1.2rem;
        line-height: 1.1;
      }
      .hero-subtitle {
        font-size: 1.25rem;
        color: var(--dark-gray);
        margin-bottom: 2.2rem;
        max-width: 480px;
      }
      .hero-buttons-redesign {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
      }
      .btn-hero {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 16px 32px;
        border-radius: 32px;
        font-size: 1.1rem;
        font-weight: 700;
        text-decoration: none;
        transition: all 0.2s;
        box-shadow: 0 2px 12px rgba(0, 97, 95, 0.07);
        border: none;
        cursor: pointer;
      }
      .btn-hero-primary {
        background: var(--primary-color);
        color: var(--light-color);
      }
      .btn-hero-primary:hover {
        background: var(--primary-dark);
        color: var(--light-color);
        transform: translateY(-2px) scale(1.03);
        box-shadow: 0 4px 18px rgba(0, 97, 95, 0.13);
      }
      .btn-hero-secondary {
        background: transparent;
        color: var(--primary-color);
        border: 2px solid var(--primary-color);
      }
      .btn-hero-secondary:hover {
        background: var(--primary-color);
        color: var(--light-color);
        transform: translateY(-2px) scale(1.03);
      }
      .btn-hero i {
        font-size: 1.2em;
      }
      .hero-image-redesign {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
      .hero-image-redesign img {
        width: 340px;
        height: 340px;
        object-fit: cover;
        border-radius: 50%;
        box-shadow: 0 8px 32px rgba(0, 97, 95, 0.13);
        border: 8px solid #fff;
        background: #fff;
      }
      @media (max-width: 992px) {
        .hero-title {
          font-size: 1.5rem;
        }
        .hero-image-redesign img {
          width: 260px;
          height: 260px;
        }
      }
      @media (max-width: 768px) {
        .hero-flex {
          flex-direction: column-reverse;
          gap: 32px;
        }
        .hero-content-redesign {
          text-align: center;
          max-width: 100%;
        }
        .hero-image-redesign {
          justify-content: center;
        }
        .hero-buttons-redesign {
          align-items: center;
        }
      }
      @media (max-width: 480px) {
        .hero-redesign {
          padding: 70px 0 40px;
        }
        .hero-title {
          font-size: 1.1rem;
        }
        .hero-image-redesign img {
          width: 160px;
          height: 160px;
        }
        .btn-hero {
          padding: 10px 10px;
          font-size: 0.95rem;
        }
      }
    `,
  ],
})
export class HeroComponent {}
